'kiwi public';

import getState from '@/libs/state';
var methods = {
  props: {},
  toggleSelfAway: function toggleSelfAway(props) {
    // let props = this.props;
    if (props.isUserSelf) {
      var val = props.user.isAway();
      props.network.ircClient.raw('AWAY', val ? '' : 'Currently away');
    }
  },
  isUserSelf: function isUserSelf(props) {
    // let props = this.props;
    if (props.toggle === false) {
      return false;
    }
    var user = getState().getUser(props.network.id, props.network.nick);
    return props.user === user;
  },
  shouldShowStatus: function shouldShowStatus(props) {
    // let props = this.props;
    if (!getState().setting('showAwayStatusIndicators')) {
      return false;
    }
    if (props.network.state !== 'connected') {
      return false;
    }
    var awayNotifyEnabled = props.network.ircClient.network.cap.isEnabled('away-notify');
    return getState().setting('buffers.who_loop') || awayNotifyEnabled;
  }
};
export default {
  props: {
    network: Object,
    user: Object,
    toggle: Boolean
  },
  m: methods
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AwayStatusIndicator"]
window._kiwi_exports.components.AwayStatusIndicator = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
